export const feedback = [
	{
		width: 120,
		title: 'Revised Status',
		field: 'revised_status',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 120,
		title: 'Approval Status',
		field: 'approval_status',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 150,
		title: 'DMP Approval Status',
		field: 'dmp_approval_status',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 250,
		title: 'DMP Approval Remark',
		field: 'dmp_approval_remark',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 170,
		title: 'DMP Attachment File',
		field: 'dmp_attachment_file',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 180,
		title: 'DMP Status Evaluated By',
		field: 'dmp_buyer_status_evaluated_by',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 180,
		title: 'DMP Status Evaluated At',
		field: 'dmp_buyer_status_evaluated_at',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 150,
		title: 'SCM Approval Status',
		field: 'scm_approval_status',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 250,
		title: 'SCM Approval Remark',
		field: 'scm_approval_remark',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 160,
		title: 'SCM Attachment File',
		field: 'scm_attachment_file',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 180,
		title: 'SCM Status Evaluated By',
		field: 'scm_buyer_status_evaluated_by',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 180,
		title: 'SCM Status Evaluated At',
		field: 'scm_buyer_status_evaluated_at',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 180,
		title: 'Logistics Approval Status',
		field: 'logistics_approval_status',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 250,
		title: 'Logistics Approval Remark',
		field: 'logistics_approval_remark',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 200,
		title: 'Logistics Attachment File',
		field: 'logistics_attachment_file',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 200,
		title: 'Logistics Status Evaluated By',
		field: 'logistics_buyer_status_evaluated_by',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 200,
		title: 'Logistics Status Evaluated At',
		field: 'logistics_buyer_status_evaluated_at',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 170,
		title: 'Supplier Packaging Cost',
		field: 'supplier_recommended_packaging_cost',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 200,
		title: 'Supplier Transportation Cost',
		field: 'supplier_recommended_transportation_cost',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 140,
		title: 'TML Packaging Cost',
		field: 'tml_recommended_packaging_cost',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 180,
		title: 'TML Transportation Cost',
		field: 'tml_recommended_transportation_cost',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 190,
		title: 'TML Settled Packaging Cost',
		field: 'tml_settled_packaging_cost',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 220,
		title: 'TML Settled Transportation Cost',
		field: 'tml_settled_transportation_cost',
		enableSearch: false,
		enableFilter: false,
	},
];

export const feedbackSupplier = [
	{
		width: 120,
		title: 'Revised Status',
		field: 'revised_status',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 120,
		title: 'Approval Status',
		field: 'approval_status',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 150,
		title: 'DMP Approval Status',
		field: 'dmp_approval_status',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 250,
		title: 'DMP Approval Remark',
		field: 'dmp_approval_remark',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 180,
		title: 'DMP Status Evaluated At',
		field: 'dmp_buyer_status_evaluated_at',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 150,
		title: 'SCM Approval Status',
		field: 'scm_approval_status',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 250,
		title: 'SCM Approval Remark',
		field: 'scm_approval_remark',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 180,
		title: 'SCM Status Evaluated At',
		field: 'scm_buyer_status_evaluated_at',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 180,
		title: 'Logistics Approval Status',
		field: 'logistics_approval_status',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 250,
		title: 'Logistics Approval Remark',
		field: 'logistics_approval_remark',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 200,
		title: 'Logistics Status Evaluated At',
		field: 'logistics_buyer_status_evaluated_at',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 170,
		title: 'Supplier Packaging Cost',
		field: 'supplier_recommended_packaging_cost',
		enableSearch: false,
		enableFilter: false,
	},
	{
		width: 200,
		title: 'Supplier Transportation Cost',
		field: 'supplier_recommended_transportation_cost',
		enableSearch: false,
		enableFilter: false,
	},
	// {
	// 	width: 140,
	// 	title: 'TML Packaging Cost',
	// 	field: 'tml_recommended_packaging_cost',
	// 	enableSearch: false,
	// 	enableFilter: false,
	// },
	// {
	// 	width: 180,
	// 	title: 'TML Transportation Cost',
	// 	field: 'tml_recommended_transportation_cost',
	// 	enableSearch: false,
	// 	enableFilter: false,
	// },
];
